import { get, post, put } from '../utils/api';

/**
 * 资产交换服务
 */
export const swapService = {
  // 创建资产交换
  createSwap: async (walletAddress, assetName, quantity) => {
    const response = await post('/swap', {
      walletAddress,
      assetName,
      quantity,
    });
    return response.data;
  },

  // 获取交换记录列表
  getSwapList: async (page = 1, size = 10, keyword = '', status = null) => {
    const params = { page, size, keyword };
    if (status !== null) params.status = status;
    const response = await get('/swap', params);
    return response.data;
  },

  // 获取用户交换记录
  getUserSwaps: async (walletAddress, page = 1, size = 10) => {
    const response = await get(`/swap/user/${walletAddress}`, { page, size });
    return response.data;
  },
};

